import { FC } from "react";
import { GapByCountyStatusBreakdown, NetworkPortfolioManagementMembership, NetworkPortfolioManagementProject } from "@app/network-portfolio-management/interfaces";
import { AccuracyInsights } from "@app/network-portfolio-management/components/AccuracyInsights";
import { AccuracyOverview } from "@app/network-portfolio-management/components/AccuracyOverview";
import { AdequacyOverview } from "@app/network-portfolio-management/components/AdequacyOverview";
import { GapByCountyStatus } from "@app/network-portfolio-management/components/GapByCountyStatus";
import {
  isAccuracyProject,
  isAdequacyProject,
  isCountyAdequacyProject,
} from "@app/network-portfolio-management/utils/projectTypeUtils";

interface ProjectCardMetricsProps {
  project: NetworkPortfolioManagementProject;
  /** The membership (primary or selected secondary) whose scores are shown. */
  selectedMembership: NetworkPortfolioManagementMembership | null;
  /** Gap by County Status for the selected membership — fetched independently, see ProjectInfiniteList. */
  gapByCountyStatus?: GapByCountyStatusBreakdown | null;
  isGapByCountyStatusLoading?: boolean;
  gapByCountyStatusHasError?: boolean;
}

// Gap/score metrics for a project card. Archived projects are reduced to identity + tags, so the
// archived check lives here once — the individual metrics below never repeat it, which keeps adding a new
// metric from silently leaking into the archived view.
export const ProjectCardMetrics: FC<ProjectCardMetricsProps> = ({
  project,
  selectedMembership,
  gapByCountyStatus,
  isGapByCountyStatusLoading = false,
  gapByCountyStatusHasError = false,
}) => {
  if (project.dateArchived != null) {
    return null;
  }

  return (
    <>
      {isCountyAdequacyProject(project.projectType) && (
        <AdequacyOverview membership={selectedMembership} projectId={project.projectId} />
      )}

      {isAdequacyProject(project.projectType) && (
        <GapByCountyStatus
          projectId={project.projectId}
          breakdown={gapByCountyStatus}
          isLoading={isGapByCountyStatusLoading}
          hasError={gapByCountyStatusHasError}
        />
      )}

      {isAccuracyProject(project.projectType) && (
        <>
          <AccuracyInsights membership={selectedMembership} projectId={project.projectId} />
          <AccuracyOverview membership={selectedMembership} projectId={project.projectId} />
        </>
      )}
    </>
  );
};
